export const expeditorProDiscountOffer = Object.freeze({
    label: "Спецусловия до 1 сентября 2026 года",
    title: "Скидка 50% на «Экспедитор Про»",
    price: {
        previous: "15 900 ₽/мес.",
        current: "7 950 ₽/мес.",
        note: "без НДС",
    },
    description:
        "Специальная цена фиксируется до конца 2026 года. Не откладывайте решение регуляторных вопросов до момента проверок.",
    action: {
        path: "/register",
        label: "Зафиксировать скидку 50% и подключить тариф",
    },
});
